module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.Connect4-9669823b65f15dab402c762834e4c0ea.jpg";